import React from "react";
import PropTypes from "prop-types";
import { Button, Grid, Paper, Typography } from "@mui/material";
import "./SummaryStep.css";
import { gradArray } from "../../../../components/form/fields/inputFields";

const paperStyle = {
  marginLeft: 10,
  paddingTop: 10,
  paddingLeft: 25,
  paddingBottom: 10,
};

function SummaryStep({ data, handleNext }) {
  const {
    title,
    lastName,
    firstName,
    birthdate,
    contractDate,
    contractDuration,
    contribution,
    degree,
    memberNumber,
    memberType,
    contractExtension,
    noticePeriod,
  } = data.memberData;

  let {
    email,
    city,
    mobile,
    phoneNumber,
    street,
    zip,
    owner,
    bank,
    iban,
    bic,
  } = data.contractData;

  let previewMemberData = (
    <Grid container>
      <Grid item lg={4} xs={12}>
        <table class="summary-table">
          <tr class="summary-table-row">
            <th>Anrede:</th>
            <td>{title}</td>
          </tr>
          <tr class="summary-table-row">
            <th>Nachname:</th>
            <td>{lastName}</td>
          </tr>
          <tr class="summary-table-row">
            <th>Vorname:</th>
            <td>{firstName}</td>
          </tr>
          <tr class="summary-table-row">
            <th>Geburtsdatum:</th>
            <td>{new Date(birthdate).toLocaleDateString()}</td>
          </tr>
        </table>
      </Grid>
      <Grid item lg={4} xs={12}>
        <table class="summary-table">
          <tr class="summary-table-row">
            <th>Art des Mitglieds: </th>
            <td>{memberType === "child" ? "Kind" : "Erwachsen"}</td>
          </tr>
          <tr class="summary-table-row">
            <th>Mitgliedsnummer: </th>
            <td>{memberNumber}</td>
          </tr>
          <tr class="summary-table-row">
            <th>Mitgliedsbeitrag: </th>
            <td>{contribution} Euro</td>
          </tr>
          <tr class="summary-table-row">
            <th>Gürtelgrad: </th>
            <td>{gradArray[degree].label}</td>
          </tr>
        </table>
      </Grid>
      <Grid item lg={4} xs={12}>
        <table class="summary-table">
          <tr class="summary-table-row">
            <th>Vertragsdatum: </th>
            <td>{new Date(contractDate).toLocaleDateString()}</td>
          </tr>
          <tr class="summary-table-row">
            <th>Vertragslaufzeit: </th>
            <td>{contractDuration} Monate</td>
          </tr>
          <tr class="summary-table-row">
            <th>Vertragsverlängerung: </th>
            <td>{contractExtension} Monate</td>
          </tr>
          <tr class="summary-table-row">
            <th>Kündigungsfrist: </th>
            <td>{noticePeriod} Monate</td>
          </tr>
        </table>
      </Grid>
    </Grid>
  );

  let previewContactData = data.contractData && (
    <Grid item lg={4} xs={12}>
      <h3 class="summary-header">Kontaktdaten</h3>
      <table class="summary-table">
        <tr class="summary-table-row">
          <th>Straße: </th>
          <td>{street}</td>
        </tr>
        <tr class="summary-table-row">
          <th>PLZ: </th>
          <td>{zip}</td>
        </tr>
        <tr class="summary-table-row">
          <th>Ort: </th>
          <td>{city}</td>
        </tr>
        <tr class="summary-table-row">
          <th>Telefon: </th>
          <td>{phoneNumber}</td>
        </tr>
        <tr class="summary-table-row">
          <th>Mobil: </th>
          <td>{mobile}</td>
        </tr>
        <tr class="summary-table-row">
          <th>E-Mail: </th>
          <td>{email}</td>
        </tr>
      </table>
    </Grid>
  );

  let previewBankData = data.contractData && (
    <Grid item lg={4} xs={12}>
      <h3 class="summary-header">Bankdaten</h3>
      <table class="summary-table">
        <tr class="summary-table-row">
          <th>Inhaber: </th>
          <td>{owner}</td>
        </tr>
        <tr class="summary-table-row">
          <th>Bank: </th>
          <td>{bank}</td>
        </tr>
        <tr class="summary-table-row">
          <th>IBAN: </th>
          <td>{iban}</td>
        </tr>
        <tr class="summary-table-row">
          <th>BIC:</th>
          <td>{bic}</td>
        </tr>
      </table>
    </Grid>
  );

  let previewContractPersonData = (
    <Grid item lg={4} xs={12}>
      <h3 class="summary-header">Vertragsperson</h3>
      <table class="summary-table">
        <tr class="summary-table-row">
          <th>Anrede: </th>
          <td>{data.contractData.title}</td>
        </tr>
        <tr class="summary-table-row">
          <th>Nachname: </th>
          <td>{data.contractData.lastName}</td>
        </tr>
        <tr class="summary-table-row">
          <th>Vorname: </th>
          <td>{data.contractData.firstName}</td>
        </tr>
        <tr class="summary-table-row">
          <th>Geburtsdatum: </th>
          <td>{new Date(data.contractData.birthdate).toLocaleDateString()}</td>
        </tr>
      </table>
    </Grid>
  );
  return (
    <div>
      <Typography
        style={{ marginBottom: 20 }}
        textAlign={"center"}
        variant="h3"
      >
        Standort: {data.site.siteName}
      </Typography>
      <Grid
        id="showData"
        component={Paper}
        elevation={9}
        style={paperStyle}
        spacing={3}
        xs={12}
      >
        <Grid item xs={12}>
          <Typography
            textAlign={"center"}
            style={{ marginBottom: 20 }}
            variant="h5"
          >
            Daten des Mitglieds
          </Typography>
        </Grid>
        {previewMemberData}

        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12}>
              <Typography
                textAlign={"center"}
                style={{ marginTop: 20 }}
                variant="h5"
              >
                Vertragsdaten
              </Typography>
            </Grid>
            {previewContractPersonData}
            {previewContactData}
            {previewBankData}
          </Grid>
        </Grid>
      </Grid>
      <Button
        onClick={handleNext}
        fullWidth
        variant="contained"
        color="secondary"
        sx={{
          mt: 2,
          mb: 3,
          fontSize: "125%",
        }}
      >
        Weiter
      </Button>
    </div>
  );
}

SummaryStep.propTypes = { data: PropTypes.object, handleNext: PropTypes.func };

export default SummaryStep;
